/**
 * Shared primitives used by every Advanced Settings section.
 * Kept here to avoid duplication across the 7 section files.
 */
import React from "react";
import { ChevronDown } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const SectionToggle = ({ icon: Icon, title, subtitle, open, onToggle, badge, testId }) => (
  <button
    data-testid={testId}
    type="button"
    onClick={onToggle}
    className="w-full flex items-center justify-between text-left py-3"
  >
    <div className="flex items-center gap-3">
      <span className="inline-flex w-8 h-8 rounded-full bg-[#F0EFEA] items-center justify-center text-[#2B5339]">
        <Icon size={15} />
      </span>
      <div>
        <div className="text-sm text-[#1C2B23] font-medium">{title}</div>
        <div className="text-[11px] text-[#5C6B62]">{subtitle}</div>
      </div>
    </div>
    <div className="flex items-center gap-3">
      {badge && (
        <span className="text-[10px] tracking-[0.18em] uppercase font-semibold text-[#2B5339] bg-[#F0EFEA] rounded-full px-2.5 py-1">
          {badge}
        </span>
      )}
      <ChevronDown
        size={16}
        className={`text-[#5C6B62] transition-transform ${open ? "rotate-180" : ""}`}
      />
    </div>
  </button>
);

export const NumInput = ({ id, label, value, onChange, suffix, prefix, step = 1, testid }) => (
  <div>
    <Label className="text-[10px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold">
      {label}
    </Label>
    <div className="mt-1.5 flex items-center bg-white border border-[#E5E2DC] rounded-lg focus-within:border-[#2B5339] transition-colors">
      {prefix && <span className="pl-3 text-[#5C6B62] text-sm">{prefix}</span>}
      <Input
        data-testid={testid || `adv-${id}`}
        id={id}
        type="number"
        value={value}
        step={step}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 text-[#1C2B23] font-mono-num text-sm py-2"
      />
      {suffix && <span className="pr-3 text-[#5C6B62] text-sm">{suffix}</span>}
    </div>
  </div>
);
